import { render } from "./textEffect.vue?vue&type=template&id=65f45072&scoped=true&ts=true"
import script from "./textEffect.vue?vue&type=script&lang=ts"
export * from "./textEffect.vue?vue&type=script&lang=ts"

import "./textEffect.vue?vue&type=style&index=0&id=65f45072&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f45072"]])

export default __exports__